/* Publish by EComposer at 2026-10-21 05:08:56*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-a0kgxn8ysjg"]=  window.__ectimmers["ecom-a0kgxn8ysjg"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-a0kgxn8ysjg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a0kgxn8ysjg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-23dqrax4eyo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-23dqrax4eyo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4vlxwhez2v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4vlxwhez2v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ptutmiu4x2l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ptutmiu4x2l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ufrtl1q4zqa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ufrtl1q4zqa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nfqw4dlmpph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nfqw4dlmpph', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hxs5k6g5do').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hxs5k6g5do', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tjmymmt683').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tjmymmt683', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wkzxda7rmss').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wkzxda7rmss', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5twxadjbvv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5twxadjbvv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-744epcr28vm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-744epcr28vm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a6zri6xd3t5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a6zri6xd3t5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gp62ue4x68').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gp62ue4x68', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8bud7qmousc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8bud7qmousc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qkckk2w7he').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qkckk2w7he', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dt0mxbc1li').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dt0mxbc1li', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qai4eknamfi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qai4eknamfi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-werourpcix').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-werourpcix', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kf9zv7515q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kf9zv7515q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ylm22zkig4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ylm22zkig4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uavodiiel8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uavodiiel8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s5duncvumvd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s5duncvumvd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ti90str9kba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ti90str9kba', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o9li8pftusj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o9li8pftusj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4iq9ap7kf68').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4iq9ap7kf68', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t36xi83zevl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t36xi83zevl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lah5436d0zm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lah5436d0zm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aacekwa3ooe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aacekwa3ooe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l1vcu5muof').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l1vcu5muof', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zo451emndu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zo451emndu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-79lxmrvyrmk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-79lxmrvyrmk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zfzcs9f1alr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zfzcs9f1alr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yrooymvbv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yrooymvbv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qym5mauuv18').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qym5mauuv18', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l296sd5aez').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l296sd5aez', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-iqj2but4p"]=  window.__ectimmers["ecom-iqj2but4p"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),s=this.settings.action;function o(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var p;(p=d.ec_splide)==null||p.refresh()})},50),r())}e.forEach((a,l)=>{s==="click"||window.screen.width<1025?a.onclick=()=>o(a,l):a.onmouseover=()=>o(a,l)});function n(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let m=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,m)}}}setTimeout(()=>{n()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",n,!1)

                    });
                    
                        document.querySelectorAll('.ecom-iqj2but4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iqj2but4p', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-v4vmhdk9qn"]=  window.__ectimmers["ecom-v4vmhdk9qn"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-v4vmhdk9qn"]["ru65nrky9"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-v4vmhdk9qn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v4vmhdk9qn', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-itjlfalfuf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-itjlfalfuf', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3n7ik0atpze').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3n7ik0atpze', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w9lfd372v0f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w9lfd372v0f', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nyho2u1u5pf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nyho2u1u5pf', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-emupvlgp7br').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-emupvlgp7br', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kinnuyonm7h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kinnuyonm7h', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-36y87f4vqlp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-36y87f4vqlp', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 $(document).ready(function () {

    $("#accordion").accordion({
        heightStyle: "content"
    });

});
} catch(error){console.error(error);}